const NAV_PARENT_ACTIVE = 'Header__nav--active';
const TOGGLE_ACTIVE     = 'NavToggle--active';
const BODY_ACTIVE       = 'page--nav-open';

class Nav {
  constructor(toggle) {
    this.toggle = toggle;
    this.target = this.toggle.dataset.target;
    this.nav    = document.querySelector(this.target)
    this.navParent = this.nav.parentNode;
    this.state  = {
      open: false
    };

    /*
      Fire 'init' again so we can make sure we get the actual height
      when the Typekit fonts are loaded.
     */
    this.toggle.addEventListener('click', this.toggleNavigation.bind(this));
    document.addEventListener('keydown', (e) => {
      if (e.keyCode && e.keyCode === 27) {
        this.closeNavigation()
      }
    })
  }

  toggleNavigation() {
    document.body.classList.toggle(BODY_ACTIVE);
    this.toggle.classList.toggle(TOGGLE_ACTIVE);
    this.navParent.classList.toggle(NAV_PARENT_ACTIVE);

    this.state.open = this.navParent.classList.contains(NAV_PARENT_ACTIVE)
  }

  closeNavigation() {
    if (this.state.open) {
      document.body.classList.remove(BODY_ACTIVE);
      this.toggle.classList.remove(TOGGLE_ACTIVE);
      this.navParent.classList.remove(NAV_PARENT_ACTIVE);
    }
  }
}

function init() {
  let toggles = [].slice.call(document.querySelectorAll('.NavToggle'))

  for (var i = 0; i < toggles.length; i++) {
    new Nav(toggles[i])
  }
}

document.addEventListener('DOMContentLoaded', init);



/** WEBPACK FOOTER **
 ** ./assets/js/lib/navigation.js
 **/